import React from "react";
import Hero from "../Components/Hero/Hero";
import Popular from "../Components/Popular/Popular";
import Offers from "../Components/Offers/Offers";
import NewCollections from "../Components/NewCollections/NewCollections";
import NewsLetter from "../Components/NewsLetter/NewsLetter";
import GoogleReview from "../Components/GoogleReview/GoogleReview";

const Shop = () => {
  return (
    <div>
      <Hero />
      <Popular />
      <NewCollections />
      <Offers />
      <GoogleReview />
      <NewsLetter />
    </div>
  );
};

export default Shop;
